import { PromotionIcon } from "./promotion-icon";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import './first-change-bonus-promotion.scss';
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import walletStore from "../../../../billing/stores/wallet/wallet-store";

const FirstChargeBonusPromotion: React.FC = ({}) => {
    const {getTranslation} = useDashboardTranslation();
    const scope = 'dashboard-onboarding';

    if (!walletStore.firstChargeBonusPromotion) {
        return null;
    }

    return (
        <div className="first-charge-bonus-promotion">
            <div className="first-charge-bonus-promotion-icon">
                <PromotionIcon />
            </div>
            <div className="first-charge-bonus-promotion-title">
                <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.NEUTRAL_WHITE}>
                    {getTranslation("GET_BONUS_CREDITS", scope, [`$${Math.round(walletStore.firstChargeBonusPromotion.amount_usd)}`])}
                </FontBody1>
                <FontBody1 color={FONT_COLOR.NEUTRAL_WHITE}>{getTranslation("WITH_YOUR_FIRST_WALLET_CHARGE", scope)}</FontBody1>
            </div>
        </div>
    );
};

export default FirstChargeBonusPromotion;